module.exports = __webpack_public_path__ + "static/media/add-open-answer-icon.7c2aa1c4.svg";